module.exports = __webpack_public_path__ + "static/img/feature_2.84d52db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/policy-manual-wizard/feature_2.png
// module id = z0m8
// module chunks = 0